export const formatPrice = price => `$${price.toFixed(2)}`;

export const prepareMadePayload = (placements, lineItem) => {
  const payload = [];

  if (placements) {
    Object.entries(placements).forEach(([index, placement]) => {
      if (placement.dtf_artwork) {
        payload.push({
          catalogNumber: lineItem.catalogNumber || lineItem.productStyle,
          isEnhancement: false,
          artworkId: placement.dtf_artwork.id,
          enhancementTier: placement.dtf_artwork.enhancementTier,
          removeBackground: placement.dtf_artwork.removeBackground,
          jiffyDesignServices: placement.dtf_artwork.jiffyDesignServices,
          width: placement.width,
          height: placement.height,
          position: placement.position,
          placement_index: index
        });
      }
    });
  }

  if (payload.length === 0 && lineItem.compositePreview?.placements) {
    lineItem.compositePreview.placements.forEach((placement, index) => {
      if (placement.artworkId) {
        payload.push({
          catalogNumber: lineItem.catalogNumber || lineItem.productStyle,
          isEnhancement: false,
          artworkId: placement.artworkId,
          width: placement.artworkWidth,
          height: placement.artworkHeight,
          position: placement.position,
          placement_index: index
        });
      }
    });
  }

  return payload;
};

export const extractBrandName = lineItem => {
  if (lineItem.brand?.name) return lineItem.brand.name;
  if (lineItem.brandName?.name) return lineItem.brandName.name;
  return lineItem.brandName || "";
};

export const extractImageUrl = lineItem => {
  if (lineItem.image?.placements?.[0]?.artwork) {
    return lineItem.image.placements[0].artwork;
  }
  return lineItem.compositePreview || lineItem.thumbnail || "";
};

export const buildSizesDisplay = (variants, variantsData) =>
  variantsData
    .filter(variant => variants[variant.id]?.quantity > 0)
    .map(variant => `${variant.size_label}: ${variants[variant.id].quantity}`)
    .join(", ");

export const calculateTotalQuantity = variants =>
  Object.values(variants || {}).reduce((sum, variant) => sum + (variant.quantity || 0), 0);

export const buildDtfData = ({ lineItem, totalPrice, totalQuantity, sizesDisplay }) => [
  {
    catalogNumber: lineItem.catalogNumber || lineItem.productStyle || "",
    color: lineItem.productColor || lineItem.colorName || "",
    brandName: extractBrandName(lineItem),
    made: true,
    isMade: true,
    soldInCase: false,
    id: lineItem.id,
    productId: lineItem.productId || lineItem.productStyle,
    image: extractImageUrl(lineItem),
    quantity: totalQuantity,
    size: sizesDisplay || "Various",
    price: formatPrice(totalPrice),
    priceTotal: formatPrice(totalPrice),
    productTitle: lineItem.productName || lineItem.name || "",
    assemblyGroupId: lineItem.assemblyGroupId,
    compositionId: lineItem.compositionId
  }
];

export const buildMadeParams = (placements, lineItem) => ({
  isMade: true,
  isEdit: false,
  madePayload: prepareMadePayload(placements, lineItem)
});
